import { IContentSetPerformance } from "@/models/interfaces/content/content-set-performance.model.interface";

export class ContentSetPerformance implements IContentSetPerformance {
    public id: number;
    public loads: number;
    public impressions: number;
    public clicks: number;
    public keyPresses: number;
    public clientConversion: number;


    constructor() {
        this.id = 0;
        this.loads = 0;
        this.impressions = 0;
        this.clicks = 0;
        this.keyPresses = 0;
        this.clientConversion = 0;
    }
}
